import { localeMapping } from 'helpers/constants/localeMapping';

const BRANDS_URL = "/brands/";
const COLLECTION_URL = "/collection/";
const SECTORS_URL = "/sectors/";
const SOLUTIONS_URL = "/solutions/";

const getRelatedProductsFilterQuery = (currentURL: string, locale: string, products: any, categoryToFetch?: string, parentProductId?: string) => {
    const localeKey = localeMapping[locale];
    const { category } = getProductInfo(products, categoryToFetch);
    const productKey = parentProductId;

    const productKeySkipFilter = `NOT key:"${productKey}"`;

    const allFilters = [
        ...getCategoryFilter(category, locale),
        productKeySkipFilter,
        ...getSolutionPagesSpecificFilterQuery(localeKey),
        ...getSectorPagesSpecificFilterQuery(),
        ...getSpecialCategoryFilterQuery()
    ];
    return allFilters.join(" AND ");
};

const getCategoryFilter = (category: any, locale: string) => {
    const localeKey = localeMapping[locale];
    const queryPath = window.location.search;
    const isSectorPage = queryPath.indexOf(SECTORS_URL) !== -1
    const isSolutionsPage = queryPath.indexOf(SOLUTIONS_URL) !== -1

    if (isSolutionsPage && queryPath.indexOf("touchless") !== -1) {
        return [` NOT categoryKeys.${localeKey}:"${category}"`];
    }
    if (isSectorPage || isSolutionsPage) {
        return [];
    }
    const categoryFilter: string[] = [`categoryKeys.${localeKey}:"${category}"`];
    return categoryFilter;
}

const getProductInfo = (products: any[], categoryToFetch?: string) => {
    const queryPath = window.location.search;
    if (
      queryPath.indexOf('lead-free') !== -1 ||
      queryPath.indexOf('hobmixer') !== -1 ||
      queryPath.indexOf('touchless') !== -1
    ) {
      return {
        category: 'Tapware',
      };
    }
    return {
      category: categoryToFetch,
    };
};
  

const getSolutionPagesSpecificFilterQuery = (localeKey: string) => {
    const queryPath = window.location.search;
    if (queryPath.indexOf("solutions") == -1) {
        return [];
    }
    const currentProductSolutions = queryPath?.split(SOLUTIONS_URL)?.[1]?.replace("/", "");
    const filterObj = { variantkey: "", brand: "", range: "" }
    switch (currentProductSolutions?.toUpperCase()) {
        case "AS14281-ACCESSIBLE":
            filterObj.variantkey = "IsAS14281Compliant";
            break;

        case "NZ4121-ACCESSIBLE":
            filterObj.variantkey = "IsNZ41121Compliant";
            break;

        case "AS14281-AMBULANT":
            filterObj.variantkey = "IsAS14281Ambulant";
            break;

        case "INDEPENDENT-LIVING":
            filterObj.variantkey = "IsIndependentLivingCompliant";
            break;

        case "TOUCHLESS-BATHROOMS":
            filterObj.variantkey = "touchless-smart";
            break;

        case "PRE-FABRICATION-FRAMES":
            filterObj.variantkey = "pre-fabrication-frames";
            break;

        case "SMART-COMMAND":
            filterObj.brand = "Caroma";
            filterObj.range = "Smart Command";
            break;
    }
    const { variantkey, brand, range } = filterObj;

    const filter = [];
    if (!!variantkey) {
        filter.push(`variants.attributes.${variantkey}:true`);
    }
    if (!!brand) {
        filter.push(`searchableAttributes.brand:"${brand}"`);
    }
    if (!!range) {
        filter.push(`searchableAttributes.range:"${range}"`);
    }
    return filter;
}

const getSectorPagesSpecificFilterQuery = () => {
    const queryPath = window.location.search;
    if (queryPath.indexOf("sectors") == -1) {
        return [];
    }
    const currentProductSolutions = queryPath?.split("/sectors/")?.[1]?.replace("/", "");
    const filterObj = { variantkey: "" }

    switch (currentProductSolutions) {

        case "healthcare":
            filterObj.variantkey = "101";
            break;

        case "multi-residential":
            filterObj.variantkey = "102";
            break;

        case "offices":
            filterObj.variantkey = "103";
            break;

        case "education":
            filterObj.variantkey = "104";
            break;

        case "retail-hospitality":
            filterObj.variantkey = "105";
            break;

        case "hotels":
            filterObj.variantkey = "106";
            break;

        case "entertainment-recreation-transports":
            filterObj.variantkey = "107";
            break;

        case "government-defense":
            filterObj.variantkey = "108";
            break;

    }
    const { variantkey } = filterObj;

    const filter = [];
    if (!!variantkey) {
        filter.push(`variants.searchableAttributes.specify-sectors:${variantkey}`);
    }
    return filter;
}

const getSpecialCategoryFilterQuery = () => {
    const queryPath = window.location.search;
    const filter = [];
    if (queryPath.indexOf("lead-free") !== -1) {
        filter.push("variants.attributes.leadfree:true");
    } else if (queryPath.indexOf("hob-mixers") !== -1) {
        filter.push("variants.attributes.hobmixer:true");
    } else if (queryPath.indexOf("touchless") !== -1) {
        filter.push("variants.attributes.touchless-smart:true");
    }

    return filter;
}



export { getRelatedProductsFilterQuery };